var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "artilleryFirelist" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _vm.$hasBtnRoles("/orders/project-delivery/initiated-by-me") ||
          _vm.$hasBtnRoles("/user/project-ticket/ticket-initiated-by-me")
            ? _c("el-tab-pane", { attrs: { label: "我发起的申请", name: "1" } })
            : _vm._e(),
          _vm.$hasBtnRoles("/material/top-tab/index")
            ? _c("el-tab-pane", { attrs: { label: "物料领取", name: "6" } })
            : _vm._e(),
          _vm.$hasBtnRoles("/orders/project-delivery/my-review") ||
          _vm.$hasBtnRoles("/user/project-ticket/my-audit")
            ? _c("el-tab-pane", { attrs: { name: "3" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.reviewCount,
                          max: 99,
                          hidden: _vm.reviewCount == 0,
                        },
                      },
                      [_vm._v(" 我的待审核 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/orders/project-delivery/my-to-do") ||
          _vm.$hasBtnRoles("/user/project-ticket/my-to-do")
            ? _c("el-tab-pane", { attrs: { label: "我的待办", name: "2" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.toDoCount,
                          max: 99,
                          hidden: _vm.toDoCount === 0,
                        },
                      },
                      [_vm._v(" 我的待办 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/orders/project-delivery/all-to-do") ||
          _vm.$hasBtnRoles("/user/project-ticket/all-to-do")
            ? _c("el-tab-pane", { attrs: { label: "全部待办", name: "5" } }, [
                _c(
                  "span",
                  { attrs: { slot: "label" }, slot: "label" },
                  [
                    _c(
                      "el-badge",
                      {
                        attrs: {
                          value: _vm.allToDoCount,
                          max: 99,
                          hidden: _vm.allToDoCount === 0,
                        },
                      },
                      [_vm._v(" 全部待办 ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$hasBtnRoles("/orders/project-delivery/division-of-labor")
            ? _c("el-tab-pane", { attrs: { label: "职能部门分工", name: "4" } })
            : _vm._e(),
        ],
        1
      ),
      (_vm.$hasBtnRoles("/orders/project-delivery/initiated-by-me") ||
        _vm.$hasBtnRoles("/user/project-ticket/ticket-initiated-by-me")) &&
      _vm.activeTab == "1"
        ? _c("startedByme")
        : _vm._e(),
      (_vm.$hasBtnRoles("/orders/project-delivery/my-review") ||
        _vm.$hasBtnRoles("/user/project-ticket/my-audit")) &&
      _vm.activeTab == "3"
        ? _c("myReview", {
            attrs: {
              reviewProjectCount: _vm.reviewProjectCount,
              reviewMallCount: _vm.reviewMallCount,
              reviewBiddingCount: _vm.reviewBiddingCount,
              reviewPrintingCount: _vm.reviewPrintingCount,
              reviewTicketCount: _vm.reviewTicketCount,
              reviewQuotationCount: _vm.reviewQuotationCount,
              reviewQuotationBindCount: _vm.reviewQuotationBindCount,
            },
            on: { countChange: _vm.handleMyReviewCountChange },
          })
        : _vm._e(),
      (_vm.$hasBtnRoles("/orders/project-delivery/my-to-do") ||
        _vm.$hasBtnRoles("/user/project-ticket/my-to-do")) &&
      _vm.activeTab == "2"
        ? _c("myToDo", {
            attrs: {
              toDoProjectCount: _vm.toDoProjectCount,
              toDoMallCount: _vm.toDoMallCount,
              toDoBiddingCount: _vm.toDoBiddingCount,
              toDoPrintingCount: _vm.toDoPrintingCount,
              toDoTicketCount: _vm.toDoTicketCount,
              toDoQuotationCount: _vm.toDoQuotationCount,
            },
            on: { countChange: _vm.handleMyToDoCountChange },
          })
        : _vm._e(),
      (_vm.$hasBtnRoles("/orders/project-delivery/all-to-do") ||
        _vm.$hasBtnRoles("/user/project-ticket/all-to-do")) &&
      _vm.activeTab == "5"
        ? _c("allToDo", {
            attrs: {
              allProjectCount: _vm.allProjectCount,
              allTaskCount: _vm.allTaskCount,
              allToDoMallCount: _vm.allToDoMallCount,
              allToDoBiddingCount: _vm.allToDoBiddingCount,
              allToDoPrintingCount: _vm.allToDoPrintingCount,
              allToDoTicketCount: _vm.allToDoTicketCount,
              allToDoQuotationCount: _vm.allToDoQuotationCount,
              allToDoCardPrintCount: _vm.allToDoCardPrintCount,
            },
            on: { countChange: _vm.handleAllToDoCountChange },
          })
        : _vm._e(),
      _vm.activeTab == "4" ? _c("FunctionalDivisionList") : _vm._e(),
      _vm.activeTab == "6" ? _c("material-receive-list") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }